import { faArrowUpToLine } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled(Stack)({
  width: "100%",
  height: "100%",
  px: 6,
  justifyContent: "center",
  alignItems: "center",
  transition: "transform 0.2s",
  ".group:hover &": {
    transform: "scale(0.95)",
  },
});

const StaticIcon = styled(FontAwesomeIcon)({
  transition: "opacity 0.2s",
  fontSize: 24,
  ".group:hover &": {
    opacity: 0,
  },
});

const BouncingIcon = styled(FontAwesomeIcon)({
  transition: "opacity 0.2s",
  fontSize: 24,
  position: "absolute",
  opacity: 0,
  ".group:hover &": {
    opacity: 0.9,
  },
});

export const DriveEmptyState = () => {
  return (
    <Root data-testid="drive-empty-state" spacing={4}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{ position: "relative" }}
      >
        <StaticIcon icon={faArrowUpToLine} />
        <BouncingIcon icon={faArrowUpToLine} bounce />
      </Stack>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{ userSelect: "none" }}
      >
        <Typography
          variant="large"
          sx={{ fontWeight: 600, textAlign: "center", opacity: 0.9 }}
        >
          Drop your files here
        </Typography>
        <Typography
          variant="small"
          sx={{ textAlign: "center", opacity: 0.75, maxWidth: 384 }}
        >
          Up to 20 files, max 10 MB each. JPEGs, PNGs or models.
        </Typography>
      </Stack>
    </Root>
  );
};
